<template>
  <div>
    <el-card>
      <div class="add_box">
        <el-table
          :data="list"
          :header-cell-style="getRowClass"
          border
          ref="multipleTable"
          style="width: 100%; flex: auto; margin-top: 20px"
          tooltip-effect="light"
        >
          <el-table-column
            prop="name"
            label="参与者名字"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="logoUrl"
            label="logo图片"
            width="150px"
            height="150px"
            align="center"
          >
            <template slot-scope="{ row }">
              <div class="vote_img">
                <img :src="row.logoUrl" alt />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="videoUrl"
            label="视频"
            width="150px"
            height="150px"
            align="center"
          >
            <template slot-scope="{ row }">
              <div class="vote_img">
                <video :src="row.videoUrl" alt />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="introduce"
            width="150px"
            label="介绍"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="sort"
            label="排序"
            align="center"
          ></el-table-column>
          <el-table-column
            align="center"
            class-name="small-padding fixed-width"
            label="操作"
            width="100px"
          >
            <template slot-scope="{ row }">
              <el-button type="primary" @click="deleteOption(row)"
               v-if="menuPerm('wenjuan:delete')"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-button type="primary" @click="addOption" style="margin: 10px 0 0px"
          v-if="menuPerm('wenjuan:insert')"
          >添加</el-button
        >
      </div>
    </el-card>

    <el-card v-if="isShow" style="margin-top: 10px">
      <el-form :model="AddList" :rules="toEdRule" ref="ruleForm">
        <el-row>
          <el-col :span="10">
            <el-form-item label="参与者名字" prop="name">
              <el-input
                placeholder="请输入内容"
                v-model="AddList.name"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="margin-left: 20px">
            <el-form-item label="sort" prop="sort">
              <el-input
                type="number"
                placeholder="请输入内容"
                v-model="AddList.sort"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item label="slogan" prop="slogan">
              <el-input
                :rows="10"
                placeholder="请输入内容"
                v-model="AddList.slogan"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item label="介绍" prop="introduce">
              <el-input
                type="textarea"
                :rows="5"
                placeholder="请输入内容"
                v-model="AddList.introduce"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="logo" prop="logoUrl" ref="logoUrl">
              <el-upload
                class="avatar-uploader"
                :action="serverUrl"
                :headers="header"
                name="img"
                :auto-upload="true"
                :show-file-list="false"
                :on-success="upSuccess"
              >
                <img
                  v-if="AddList.logoUrl"
                  :src="AddList.logoUrl"
                  class="avatar"
                  style="width: 100%; height: auto"
                />

                <i
                  :class="
                    loadUpt
                      ? 'el-icon-loading'
                      : 'el-icon-plus avatar-uploader-icon'
                  "
                  style="margintop: 10px; font-size: 50px"
                  v-else
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上传视频" prop="videoUrl" ref="videoUrl">
              <el-upload
                :auto-upload="true"
                :on-change="videoUp"
                :on-success="videoListSuccess"
                :show-file-list="false"
                :action="serverUrl"
                :headers="header"
                name="img"
                class="audio-upt"
                ref="uptImg"
              >
                <video
                  :src="AddList.videoUrl"
                  class="video"
                  controls="controls"
                  v-if="AddList.videoUrl"
                ></video>
                <i
                  :class="
                    shipinLoadUpt
                      ? 'el-icon-loading'
                      : 'el-icon-plus avatar-uploader-icon'
                  "
                  style="margintop: 5px; font-size: 50px"
                  v-else
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row> </el-row>
        <el-row>
          <el-button type="primary" @click="submitEdit('ruleForm')"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </el-card>
    <!-- 删除弹框 -->
    <a-modal v-model="visible" on-ok="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel"> 取消 </a-button>
        <a-button key="submit" type="primary" @click="handleOk">
          确定
        </a-button>
      </template>
      <p>确定删除吗?</p>
    </a-modal>
  </div>
</template>
<script>
import {baseURL} from '../../api/config'
export default {
  props: ["ParticipantData"],

  data() {
    var valiIcon = (rule, value, callback) => {
      // 图片验证

      if (this.AddList.logoUrl == "") {
        callback(new Error("不能为空"));
      } else {
        callback();
      }
    };
    return {
      visible: false,
      loadUpt: false,
      shipinLoadUpt: false,
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      imgLoad: false, //加载load
      AddList: {
        name: "", //参与者名字
        logoUrl: "", //logo 图片路径
        introduce: "", //介绍
        slogan: "", //slogan
        activityId: "", //问卷表 id
        videoUrl: "", //视频链接
        sort: "", //排名
      },
      toEdRule: {
        name: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        introduce: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        slogan: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        sort: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        logoUrl: [{ required: true, validator: valiIcon, trigger: "blur" }],
      },
      list: [],
      isShow: false,
      deleteId: "",
    };
  },
  mounted() {
    this.getList();
  },
  watch: {
    ParticipantData(newVal, oldVal) {
      this.getList();
    },
  },
  methods: {
    // 删除取消弹框
    handleCancel() {
      this.visible = false;
    },
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    // 添加参与者
    addOption() {
      this.isShow = true;
    },
    handleOk() {
      this.getAxios(`/wenjuan/delete/activityPlayer?id=${this.deleteId}`).then(
        (res) => {
          if (res.success == true) {
            this.$message.success(res.message);
            this.visible = false;
            this.getList();
          }
        }
      );
    },
    deleteOption(row) {
      this.visible = true;
      this.deleteId = row.id;
    },
    upSuccess(file) {
      this.AddList.logoUrl = file.entity;
      //   if (file.entity) {
      //     this.$refs.coverUrl.clearValidate();
      //   }
    },
    getList() {
      this.getAxios(`/wenjuan/detail?id=${this.ParticipantData.id}`).then(
        (res) => {
          this.list = res.entity.playerList;
        }
      );
    },
    //视频上传成功
    videoListSuccess(res, file) {
      this.shipinLoadUpt = false;
      this.AddList.videoUrl = res.entity;
      //   this.$refs.uptImg.clearValidate();
    },
    videoUp(file, fileList) {
      if (file) {
        this.shipinLoadUpt = true;
      }
    },
    submitEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/wenjuan/add/activityPlayer", {
            name: this.AddList.name, //参与者名字
            logoUrl: this.AddList.logoUrl, //logo图
            introduce: this.AddList.introduce, //介绍
            slogan: this.AddList.slogan,
            activityId: this.ParticipantData.id,
            videoUrl: this.AddList.videoUrl,
            sort: this.AddList.sort,
          }).then((res) => {
            if (res.success == true) {
              this.$message.success(res.message);
              this.getList();
              this.AddList = {};
              this.shipinLoadUpt = false;
              this.isShow = false;
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (res.success == false && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
/deep/ .el-upload {
  width: 200px;
  height: auto;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  outline: 0;
  border: 2px dashed #eee;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.vote_img img {
  width: 100%;
}
video {
  width: 150px;
  height: 150px;
}
</style>